import React, { ChangeEvent } from 'react'
import styles from './topBanner.module.css'
import { FaWhatsapp, FaViber, FaPhoneAlt, FaFacebook, FaTiktok } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const TopBanner = () => {
    const { i18n } = useTranslation()
    const handleChangeLng = (e: ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value)
    }

    return (
        <div className={styles.top_banner_wrapper}>
            <div className={`app_container ${styles.top_banner}`}>
                <div className={styles.phones}>
                    <a href="tel:+37494093388" className={styles.phone_link}>
                        <FaPhoneAlt className={styles.phone_icon} />
                        <span>+374 94 09 33 88</span>
                    </a>
                    <span className={styles.divider}>|</span>
                    <a href="tel:+37494173433" className={styles.phone_link}>
                        <FaPhoneAlt className={styles.phone_icon} />
                        <span>+374 94 17 34 33</span>
                    </a>
                </div>

                <div className={styles.right_group}>
                    <a href="https://wa.me/37494173433" className={`${styles.social_link} ${styles.social_wa}`} target="_blank" rel="noreferrer" aria-label="WhatsApp">
                        <FaWhatsapp className={styles.social_icon} />
                    </a>
                    <a href="viber://chat?number=%2B37494173433" className={`${styles.social_link} ${styles.social_vb}`} aria-label="Viber">
                        <FaViber className={styles.social_icon} />
                    </a>
                    <a href="https://www.facebook.com/svecha.am" className={`${styles.social_link} ${styles.social_fb}`} target="_blank" rel="noreferrer" aria-label="Facebook">
                        <FaFacebook className={styles.social_icon} />
                    </a>
                    {/* TikTok — заглушка, пока не настроен (заменить href на реальную ссылку) */}
                    <a href="#" onClick={(e) => e.preventDefault()} className={`${styles.social_link} ${styles.social_tt}`} aria-label="TikTok" title="Скоро">
                        <FaTiktok className={styles.social_icon} />
                    </a>
                    <span className={styles.divider}>|</span>
                    <select className={styles.language} onChange={handleChangeLng}>
                        <option value="am">AM</option>
                        <option value="ru">RU</option>
                        <option value="en">EN</option>
                    </select>
                </div>
            </div>
        </div>
    )
}

export default TopBanner
